// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { implicitReturnType } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    commonGetApiV1Time (params?: {}): Promise<implicitReturnType>;
    commonGetApiV1Ping (params?: {}): Promise<implicitReturnType>;
    commonGetApiV1ExchangeInfo (params?: {}): Promise<implicitReturnType>;
    commonGetQuoteV1Depth (params?: {}): Promise<implicitReturnType>;
    commonGetQuoteV1DepthMerged (params?: {}): Promise<implicitReturnType>;
    commonGetQuoteV1Trades (params?: {}): Promise<implicitReturnType>;
    commonGetQuoteV1Klines (params?: {}): Promise<implicitReturnType>;
    commonGetQuoteV1IndexKlines (params?: {}): Promise<implicitReturnType>;
    commonGetQuoteV1IndexPriceComponents (params?: {}): Promise<implicitReturnType>;
    commonGetQuoteV1MarkPriceKlines (params?: {}): Promise<implicitReturnType>;
    commonGetQuoteV1MarkPrice (params?: {}): Promise<implicitReturnType>;
    commonGetQuoteV1Index (params?: {}): Promise<implicitReturnType>;
    commonGetQuoteV1Ticker24hr (params?: {}): Promise<implicitReturnType>;
    commonGetQuoteV1ContractTicker24hr (params?: {}): Promise<implicitReturnType>;
    commonGetQuoteV1TickerPrice (params?: {}): Promise<implicitReturnType>;
    commonGetQuoteV1ContractTickerPrice (params?: {}): Promise<implicitReturnType>;
    commonGetQuoteV1TickerBookTicker (params?: {}): Promise<implicitReturnType>;
    commonGetQuoteV1ContractTickerBookTicker (params?: {}): Promise<implicitReturnType>;
    commonGetApiV1FuturesFundingRate (params?: {}): Promise<implicitReturnType>;
    commonGetApiV1FuturesHistoryFundingRate (params?: {}): Promise<implicitReturnType>;
    commonGetApiV1FuturesRiskLimits (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1Account (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AccountCheckApiKey (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1SpotOrder (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1SpotOpenOrders (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1FuturesOpenOrders (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1SpotTradeOrders (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1FuturesHistoryOrders (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AccountTrades (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AccountBalanceFlow (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AccountDepositOrders (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AccountWithdrawOrders (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AccountDepositAddress (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1SubAccount (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AccountSubAccount (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1SubAccountList (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1FuturesAccountLeverage (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1FuturesOrder (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1FuturesPositions (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1FuturesHistoryPositions (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1FuturesBalance (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1FuturesUserTrades (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1FuturesBalanceFlow (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1FuturesCommissionRate (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1FuturesTodayPnl (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AccountDownloadDetail (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AgentInviteUserList (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AgentCommissionDataList (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AgentCommissionDataInfo (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AgentInviteRelationCheck (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AgentDepositDetailList (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AgentQuerySubAgentData (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AgentSpotOrdersList (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AgentFuturesOrdersList (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AgentFuturesPositionsList (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AgentInviteCommissionDetail (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AgentUserExport (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AgentExportList (params?: {}): Promise<implicitReturnType>;
    privateGetApiV1AgentExportUrl (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1SpotOrderTest (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1SpotOrder (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1FuturesOrder (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1SpotBatchOrders (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1SubAccountTransfer (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1AccountWithdraw (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1FuturesMarginType (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1FuturesLeverage (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1FuturesBatchOrders (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1FuturesPositionTradingStop (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1FuturesPositionMargin (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1FuturesOrderUpdate (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1FuturesAutoAddMargin (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1FuturesFlashClose (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1FuturesReversePosition (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1AccountDownloadApply (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1UserDataStream (params?: {}): Promise<implicitReturnType>;
    privatePostApiV1ListenKey (params?: {}): Promise<implicitReturnType>;
    privateDeleteApiV1SpotOrder (params?: {}): Promise<implicitReturnType>;
    privateDeleteApiV1FuturesOrder (params?: {}): Promise<implicitReturnType>;
    privateDeleteApiV1SpotOpenOrders (params?: {}): Promise<implicitReturnType>;
    privateDeleteApiV1FuturesBatchOrders (params?: {}): Promise<implicitReturnType>;
    privateDeleteApiV1SpotCancelOrderByIds (params?: {}): Promise<implicitReturnType>;
    privateDeleteApiV1FuturesCancelOrderByIds (params?: {}): Promise<implicitReturnType>;
    privateDeleteApiV1UserDataStream (params?: {}): Promise<implicitReturnType>;
    privateDeleteApiV1ListenKey (params?: {}): Promise<implicitReturnType>;
    privatePutApiV1UserDataStream (params?: {}): Promise<implicitReturnType>;
    privatePutApiV1ListenKey (params?: {}): Promise<implicitReturnType>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
